export default __webpack_public_path__ + "static/media/Helm of the Bloodmoon.70be2f93.jpg";